<div class="container">
    <app-shell 
        style="width: 100%; height: 100%;" 
        [disableDocuments]="true"
    >
        <div class="company-address stack">
            <div id="question">
                <h1>{{this.questionText}}</h1>
            </div>

            <div id="question-answer">
                <div class="address-grid">
                    <ng-container [formGroup]="form">

                        <!-- Address1 -->
                        <div class="grid-item">
                            <app-kendo-textbox 
                                inputText="Address1" 
                                formControlName="address1" 
                                inputType="text"
                                [parentForm]="form"
                                [maxLength]="200"
                                (keyup.enter)="onEnter()"
                            ></app-kendo-textbox>
                            <div 
                                *ngIf=" this.form.get('address1')?.invalid &&(this.form.get('address1')?.dirty ||
                                        this.form.get('address1')?.touched)"
                            >
                                <kendo-formerror 
                                    *ngIf="this.form.get('address1')?.errors?.['required']"
                                >
                                    Enter address's first line
                                </kendo-formerror>
                            </div>
                        </div>


                        <!-- Address2 -->
                        <div class="grid-item">
                            <app-kendo-textbox 
                                inputText="Address2" 
                                formControlName="address2" 
                                inputType="text"
                                [parentForm]="form"
                                [maxLength]="200"
                                (keyup.enter)="onEnter()"
                            ></app-kendo-textbox>

                            <div 
                                *ngIf=" this.form.get('address2')?.invalid &&(this.form.get('address2')?.dirty ||
                                    this.form.get('address2')?.touched)"
                            >
                                <kendo-formerror 
                                    *ngIf="this.form.get('address2')?.errors?.['required']"
                                >
                                    Enter address's second line
                                </kendo-formerror>
                            </div>
                        </div>


                        <!-- City -->
                        <div class="grid-item">
                            <app-kendo-textbox 
                                inputText="City" 
                                formControlName="city" 
                                inputType="text"
                                [parentForm]="form"
                                (keyup.enter)="onEnter()"
                            ></app-kendo-textbox>

                            <div 
                                *ngIf="this.form.get('city')?.invalid &&(this.form.get('city')?.dirty ||
                                    this.form.get('city')?.touched)"
                            >
                                <kendo-formerror 
                                    *ngIf="this.form.get('city')?.errors?.['required']"
                                >
                                    Enter address's city
                                </kendo-formerror>
                            </div>
                        </div>

                        <!-- State -->
                        <div class="grid-item">
                            <app-kendo-dropdown 
                                [dropdownHeaderText]="'State'" 
                                [options]="options" 
                                formControlName="state"
                                (selectionChange)="selectionChange($event)"
                                [defaultOption]="defaultOption"
                            ></app-kendo-dropdown>

                            <div 
                                *ngIf=" this.form.get('state')?.invalid &&(this.form.get('state')?.dirty ||
                                    this.form.get('state')?.touched)"
                            >
                                <kendo-formerror 
                                    *ngIf="this.form.get('state')?.errors?.['required']"
                                >
                                    Please choose one of the options
                                </kendo-formerror>
                            </div>
                        </div>


                        <!-- zipcode -->
                        <div class="grid-item">
                            <app-kendo-textbox 
                                inputText="Zipcode" 
                                formControlName="zipCode" 
                                inputType="text"
                                [parentForm]="form"
                                (keyup.enter)="onEnter()"
                            ></app-kendo-textbox>
                            <div 
                                *ngIf=" this.form.get('zipCode')?.invalid &&(this.form.get('zipCode')?.dirty ||
                                    this.form.get('zipCode')?.touched)"
                            >
                                <kendo-formerror 
                                    *ngIf="this.form.get('zipCode')?.errors?.['required']"
                                >
                                    Enter address's zipcode
                                </kendo-formerror>
                                <kendo-formerror 
                                    *ngIf="this.form.get('zipCode')?.errors?.['pattern']"
                                >
                                    Enter a valid zipcode
                                </kendo-formerror>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="button-wrapper">
                <app-stateful-primary-button 
                    type="submit" 
                    [clickEvent]="this.submit.bind(this)" 
                    [text]="'Next'"
                    [pageUrl]="this.nextState['pageUrl']" 
                    [stateId]="this.nextState['id']"
                    #submitButton    
                ></app-stateful-primary-button>
            </div>

            <div id="bottom-nav">
                <div id="back">
                    <app-stateful-secondary-button type="submit" [text]="'Back'"
                        [pageUrl]="this.backState['pageUrl']"
                        [stateId]="this.backState['id']"></app-stateful-secondary-button>
                </div>
                <div id="skip">
                    <app-stateful-secondary-button type="submit" [text]="'Skip'"
                        [pageUrl]="this.skipState['pageUrl']"
                        [stateId]="this.skipState['id']"></app-stateful-secondary-button>
                </div>
            </div>
        </div>
    </app-shell>
</div>